import { lazy, Suspense } from 'react';
import { Navigate, RouteObject } from 'react-router';
import { Spin } from 'antd';
import { ProtectedRoutes } from '@/router/ProtectedRoutes.tsx';

const NavBreakdownReportPage = lazy(() => import('./nav-breakdown-report-page.tsx'));
const NavBreakdownAnalyticsView = lazy(() =>
  import('./nav-breakdown-report-page.tsx').then(({ NavBreakdownReportView }) => ({
    default: NavBreakdownReportView,
  })),
);

/** The NAV Breakdown tab body under the Analytics shell; the shell owns the permission guard. */
export const navBreakdownAnalyticsRoute: RouteObject = {
  path: 'nav-breakdown',
  element: (
    <Suspense fallback={<Spin />}>
      <NavBreakdownAnalyticsView />
    </Suspense>
  ),
};

// UX gate only; ReportsController's [AuthorizeRoles] + [AuthorizeFunction] attributes are the
// security boundary.
export const reportsRoutes: RouteObject = {
  path: 'reports',
  element: (
    <ProtectedRoutes
      requiredPermissions={[
        { moduleName: 'investor-management', functionName: 'read-investor-profile' },
      ]}
    />
  ),
  children: [
    // Only one report exists today, so the section root lands on it.
    { index: true, element: <Navigate to="nav-breakdown" replace /> },
    {
      path: 'nav-breakdown',
      element: (
        <Suspense fallback={<Spin />}>
          <NavBreakdownReportPage />
        </Suspense>
      ),
    },
  ],
};
